import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from '@material-ui/core';
import { setOverAllDesignSummary } from "../../redux/actions/leadSourceActions";
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from "@material-ui/core/Grid";
import Tooltip from '@material-ui/core/Tooltip';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    withStyles,
    Checkbox,
    TableContainer,
    Box
} from "@material-ui/core";
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button } from "antd";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME, salesDepartment } from '../../utils/index';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    bordercolors: {
        border: '1px solid #eee5e5',
        background: "blue"
    },
    table: {
        minWidth: 700,
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    customTableContainer: {
        overflowX: "initial"
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginpivotRight: theme.spacing(1),
        width: 200,
    },
    table: {
        width: "fit-content",
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    leadSearchButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    leadClearButton: {
        backgroundColor: '#f7b7b7', // light red background
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        // "&:hover": { 
        //     backgroundColor: "#f7b7b7", // same light red on hover
        //     color: '#151921' // same text color on hover
        // }
    },
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
          backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
      },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500"
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const DesignSummary = (props) => {
    const classes = useStyles();
    const { userDetails } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const designData = useSelector((state) => state.leadSource.designSummary);
    const [store, setStore] = useState([]);
    const [commonExpCenter, setExpCenter] = useState([])
    const [commonLocation, setLocation] = useState([])
    const [pivot, setPivot] = useState("overallSummary")
    const [storeDateFilter, setPivotDatefilters] = useState({ startDate: "", endDate: "" })
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
    const [selectedLocation, setSelectedLocation] = useState([])
    const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', "Oct", "Nov", "Dec"];
    const [selectedValue, setSelectedValue] = useState("");
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const [popMonthData, setPopMonthData] = useState([]);
    const [selectedRole, setSelectedRole] = useState('');
    const [usersData, setUsersData] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [status, setStaus] = useState('');
    const [selectLost, setSeletLost] = useState('')
    const [searchInput, setSearchInput] = useState("")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const [storeUserGroupDetails, setUserGroupDetails] = useState([])
    const [showNewTable, setShowNewTable] = useState(false); // For toggling the table visibility
    const [groupedTable, setGroupedTable] = useState([])
    const [groups, setGroups] = useState([]);
    const [storeHeadings, setStoreHeadings] = useState([])
    const [storeRowsData, setStoreRowsData] = useState([])
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No']
    const [dynamicDataShow, setDynamicDataShow] = useState(0)
    const THIRD_BUTTON_DISABLE_UNTIL_KEY = 'thirdButton_disableUntil';
    const [isDisabled, setIsDisabled] = useState(false);
    const [shouldRefresh, setShouldRefresh] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);
   const [isSpinning, setIsSpinning] = useState(false);
   const [lastUsedParams, setLastUsedParams] = useState(null);
   const [isInitialRender, setIsInitialRender] = useState(true);


    const displayDate = (month, year) => {
        const shortYear = year.toString().slice(-2); // Get the last two digits of the year

        // Check if the month includes a `/`, indicating multiple months
        if (typeof month === 'string' && month.includes('/')) {
            const monthCodes = month.split('/').map(code => parseInt(code)); // Convert each to an integer
            monthCodes.sort((a, b) => a - b); // Sort the month codes in ascending order
            const monthNames = monthCodes.map(code => months[code]); // Convert each code to month name
            return `${monthNames.join('/')} - ${shortYear}`; // Join with a slash and append the short year
        } else {
            // Single month case
            return `${months[parseInt(month)]} - ${shortYear}`;
        }
    };


    useEffect(() => {
        expCenters();
        locations();
        fetchUsersData();
        if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            overallsummary()
            setSelectedRole(ROLENAME.SalesUser)
        } else if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            overallsummary()
            setSelectedRole(ROLENAME.DesignUser)
        } else {
            setSelectedRole("ALL")
            overallsummary();
        }
    }, []);

    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        { key: "designUser", label: "Design User" },
        { key: "designAssistantManager", label: "Design Assistant Manager" },
        { key: "designManager", label: "Design Manager" },
        { key: "designDGM", label: "Design DGM" },
        { key: "designStage", label: "Design Stage" },
        { key: "currentStage", label: "Current Stage" },
        { key: "totalValue", label: "Value (INR)" },
        { key: "location", label: "City" },
        { key: "expCtrName", label: "Exp. Ctr Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "designSignOffDate", label: "Design Sign-Off Date" },
        { key: "materialDeliveryDate", label: "Material Delivery Date" },
        { key: "actualCompletionDate", label: "Actual Completion Date" },
    ];



    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < popMonthData.length; i++) {
                let obj = {
                    serialNo: i + 1,
                    projectCode: popMonthData[i]?.leadId?.erpProjectNo || "N/A",
                    leadNumber: popMonthData[i]?.leadId?.lead_no || "N/A",
                    clientName: popMonthData[i]?.leadId?.customerId?.name,
                    totalValue:
                        (status === 'completed'
                            ? (popMonthData[i]?.leadId?.staticDesignWonAmount
                                ? (popMonthData[i].leadId.staticDesignWonAmount / 1.18) / 100000
                                : "N/A")
                            : (popMonthData[i]?.leadId?.staticSalesWonBudget
                                ? popMonthData[i].leadId.staticSalesWonBudget
                                : "N/A")),
                    location: popMonthData[i]?.salesExpCenter?.locationId?.name,
                    expCtrName: popMonthData[i]?.salesExpCenter?.name,
                    salesWonDate: popMonthData[i]?.SalesWonDate
                        ? moment(popMonthData[i]?.SalesWonDate).format("DD-MM-YYYY")
                        : "-",
                    salesUser: popMonthData[i]?.salesUser ? popMonthData[i]?.salesUser?.name : 'NA',
                    salesManager: popMonthData[i]?.salesManager ? popMonthData[i]?.salesManager?.name : 'NA',
                    salesDGM: popMonthData[i]?.salesDGM ? popMonthData[i]?.salesDGM?.name : 'NA',
                    salesAssistantManager: popMonthData[i]?.salesAssistantManager ? popMonthData[i]?.salesAssistantManager?.name : 'NA',
                    designUser: popMonthData[i]?.designUser ? popMonthData[i]?.designUser?.name : 'NA',
                    designManager: popMonthData[i]?.designManager ? popMonthData[i]?.designManager?.name : 'NA',
                    designDGM: popMonthData[i]?.designDGM ? popMonthData[i]?.designDGM?.name : 'NA',
                    designAssistantManager: popMonthData[i]?.designAssistantManager ? popMonthData[i]?.designAssistantManager?.name : 'NA',
                    currentStage: popMonthData[i]?.leadId?.currentStage ? popMonthData[i]?.leadId?.currentStage : 'NA',
                    designStage: popMonthData[i]?.stage ? popMonthData[i]?.stage : "NA",
                    designSignOffDate: popMonthData[i]?.leadId?.customerDesignSignOffDate
                        ? moment(popMonthData[i]?.leadId?.customerDesignSignOffDate).format("DD-MM-YYYY")
                        : "-",
                    materialDeliveryDate: popMonthData[i]?.leadId?.materialDispatchedDate
                        ? moment(popMonthData[i]?.leadId?.materialDispatchedDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    actualCompletionDate: popMonthData[i]?.leadId?.executionCompletionDate
                        ? moment(popMonthData[i]?.leadId?.executionCompletionDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                };
                csvArray.push(obj);
                // obj = {
                //     serialNo: "",
                //     projectCode: "",
                //     clientName: "",
                //     totalValue: "",
                //     expCtrName: "",
                //     salesWonDate: "",
                //     designSignOffDate: "",
                //     materialDeliveryDate: "",
                //     actualCompletionDate: "",
                // };
                // csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {

            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };
    const expCenterData = {};
    store.forEach((el) => {
        if (!expCenterData[el.experienceCenterName]) {
            expCenterData[el.experienceCenterName] = [];
        }
        expCenterData[el.experienceCenterName].push(el);
    });
    const uniqueexperienceCenterCode = Array.from(new Set(store.map((el) => el.expCenterCode)));
    let uniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));


    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user => {
                return userDetails.experienceCenterId.includes(user._id);
            });
            setExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }


    const locations = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getLocation();
            const matchedUsers = response.data.filter(user => {
                return userDetails.selectedLocation.includes(user._id);
            });
            setLocation(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const isEqual = (obj1, obj2) => {
        // First check if both objects have the same keys
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        // Check if all keys in obj2 exist in obj1
        for (const key of keys2) {
            if (!keys1.includes(key)) {
                return false;
            }
        }

        // Then compare each key's value
        for (const key in obj1) {
            if (Array.isArray(obj1[key])) {
                // For arrays, check if they have the same length and same items
                if (!Array.isArray(obj2[key]) || obj1[key].length !== obj2[key].length) {
                    return false;
                }

                // For arrays of objects with _id, compare by _id
                if (obj1[key].length > 0 && obj1[key][0]?._id) {
                    const obj1Ids = new Set(obj1[key].map(item => item._id));
                    const obj2Ids = new Set(obj2[key].map(item => item._id));

                    // Check if sets are equal
                    if (obj1Ids.size !== obj2Ids.size) {
                        return false;
                    }

                    for (const id of obj1Ids) {
                        if (!obj2Ids.has(id)) {
                            return false;
                        }
                    }
                } else {
                    // Simple comparison for primitive arrays
                    for (let i = 0; i < obj1[key].length; i++) {
                        if (obj1[key][i] !== obj2[key][i]) {
                            return false;
                        }
                    }
                }
            } else if (obj1[key] !== obj2[key]) {
                return false;
            }
        }

        return true;
    };

    const overallsummary = async (addLocation, addExpCenter, usersData, selectedSearchType, searchInput) => {
        let locationData = addLocation?.map((el) => el._id)
        let expCenterData = addExpCenter?.map((el) => el._id)
        let users = ''
        if ((usersData?.users && usersData?.users.length !== 0) || (selectedUsers && selectedUsers.length !== 0)) {
            users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id)
        }
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            tokenPercentage: selectedValue !== "" ? selectedValue : "",
            users: users ? users : "",
            // selectedRole: usersData?.role ? usersData?.role : ROLENAME.DesignUser,
            userExpCenter: userDetails.experienceCenterId,
            userLocation: userDetails.selectedLocation,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.DesignUser
        } else if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.SalesUser
        } else {
            obj.selectedRole = usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL")
        }
        // Determine if we need to make API call
        let shouldMakeApiCall = false;
          
        // Case 1: No salesData - must call API
        if (!designData ||  designData === null) {
            shouldMakeApiCall = true;
        } 
        // Case 2: Not initial render AND parameters changed
        else if (!isInitialRender && lastUsedParams && !isEqual(lastUsedParams, obj)) {
            shouldMakeApiCall = true;
        }

        props.setLoading(true);
        try {
            // setTimeout(async()=>{
            //     console.log("design ->", designData)
            //     if(designData === null) {
            //         let response = await HttpService.overallSummaryDashBoard(obj);
            //         setStore(response.data.data);
            //         dispatch(setOverAllDesignSummary(response.data.data));
            //         }else{
            //             setStore(designData)
            //         }
            // },600)
          
            if (shouldMakeApiCall) {
                // Call API with current parameters
                let response = await HttpService.overallSummaryDashBoard(obj);
                setStore(response.data.data);
                dispatch(setOverAllDesignSummary(response.data.data));
            } else {
                // Use existing data
                setStore(designData);
            }
            
            // Always save the current parameters
            setLastUsedParams({...obj});
            
            // No longer initial render after first execution
            if (isInitialRender) {
                setIsInitialRender(false);
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }


    // const checkPivot = async (value) => {
    //     setPivot(value)
    //     if (value === 'value' || value === 'total') {
    //         overallsummary()
    //         setSelectedExperienceCenter([])
    //         setSelectedUsers([])
    //         setSelectedRole("ALL")
    //         handleSelectRoles(null, ROLENAME.SalesUser)
    //     } else if (value === "overallReview") {
    //         overallReview();
    //         setSelectedExperienceCenter([])
    //         setSelectedUsers([])
    //         setSelectedRole(ROLENAME.DesignUser)
    //         handleSelectRoles(null, ROLENAME.DesignUser)
    //     } else if (value === "overallsummary") {
    //         overallsummary()
    //         setSelectedExperienceCenter([])
    //         setSelectedUsers([])
    //         setSelectedRole("ALL")
    //         handleSelectRoles(null, ROLENAME.DesignUser)
    //     }
    //     else if (value === 'lost') {
    //         lastDataAnalaysis()
    //         setSelectedExperienceCenter([])

    //     } else if (value === 'salesOverallReview') {
    //         salesOverallReview()
    //         setSelectedExperienceCenter([])
    //         setSelectedUsers([])
    //         setSelectedRole(ROLENAME.SalesUser)
    //         handleSelectRoles(null, ROLENAME.SalesUser)
    //     } else if (value === 'designSignOffReview') {
    //         designSignOffReview()
    //         setSelectedExperienceCenter([])
    //     }
    // }

    const formatNumberToTwoDecimalPlaces = (value) => {
        return parseFloat(value).toFixed(2);
    }

    const storePivotDate = (e) => {
        const { name, value } = e.target
        setPivotDatefilters({ ...storeDateFilter, [name]: value })
    }
    const handlePivotDateFilter = async () => {
        if (dynamicDataShow !== 0) {
            await overallSummaryDashBoardGroupWise(selectedLocation, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput, selectedGroup)
        } else {
            overallsummary(selectedLocation, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
        }

    }

    const handleSelectChange = async (event) => {
        if (dynamicDataShow !== 0) {
            setSelectedValue(event.target.value);
            let locationData = selectedLocation?.map((el) => el._id)
            let expCenterData = selectedExperienceCenter?.map((el) => el._id)
            let obj = {
                startDate: storeDateFilter.startDate,
                endDate: storeDateFilter.endDate,
                selectedLocation: locationData ? locationData : "",
                selectedExperienceCenter: expCenterData ? expCenterData : "",
                userLocation: userDetails.selectedLocation,
                userExpCenter: userDetails.selectedExpCenter,
                tokenPercentage: event.target.value !== "" ? event.target.value : "",
                lost: selectLost !== "" ? selectLost : "",
                groupId: selectedGroup
            }
            props.setLoading(true);
            try {
                let users = ''
                if (selectedUsers && selectedUsers.length !== 0) {
                    users = selectedUsers?.map((el) => el._id)
                }
                obj.users = users ? users : ""
                obj.selectedRole = selectedRole
                let response = await HttpService.overallSummaryDashBoardGroupWise(obj);

                const organizedData = response.data.organizedData.data;


                const processedData = organizedData.map(item => {
                    const { totalCount, grandTotal, month, year, details,
                        selectedRows, detailsArray } = item;

                    // Step 1: Extract details by filtering out keys that contain 'count'
                    const filteredDetails = [];
                    if (details) {
                        for (const [key, value] of Object.entries(details)) {
                            if (!key.toLowerCase().includes("count")) {
                                filteredDetails.push({ [key]: value });
                            }
                        }
                    }

                    // Step 2: Extract headings that include '/' in `detailsArray`
                    // Create a Set to store unique headings containing '/'
                    // Initialize a Set to store unique headings temporarily
                    const uniqueHeadingsSet = new Set();

                    if (detailsArray && detailsArray.length > 0) {
                        detailsArray.forEach(detail => {
                            Object.keys(detail).forEach(detailKey => {
                                if (detailKey.includes('/')) {
                                    uniqueHeadingsSet.add(detailKey); // Add to Set to ensure uniqueness
                                }
                            });
                        });
                    }

                    // Convert Set to Array for new headings only
                    const filteredHeadings = Array.from(uniqueHeadingsSet);

                    // Conditionally update `storeHeadings` to add only new unique headings
                    setStoreHeadings((prevStoreHeadings) => {
                        // Create a combined set to avoid duplicates
                        const newUniqueHeadings = new Set([...prevStoreHeadings, ...filteredHeadings]);

                        // Convert to array for consistency and to avoid re-renders due to reference change
                        const updatedHeadingsArray = Array.from(newUniqueHeadings);
                        return updatedHeadingsArray;
                    });


                    //   let  filteredMonths ;

                    const filteredMonths = [];

                    // Check if `month` is a string and contains '/'
                    if (selectedRows && selectedRows.length > 0) {
                        // Concatenate selected rows using '/'
                        const concatenatedRows = selectedRows.join('/'); // e.g., '1-23/2-24'



                        // Update storeRowsData
                        setStoreRowsData(prevStored => {
                            // Check if the concatenated row already exists
                            if (!prevStored.includes(concatenatedRows)) {
                                return [...prevStored, concatenatedRows]; // Add new concatenated row if it doesn't exist
                            }
                            return prevStored; // Return unchanged state if it exists
                        });
                    }


                    // Collect headings in `setStoreHeadings`


                    // Step 3: Filter `detailsArray` items that have either a non-zero count or explicitly defined zero values
                    const filteredDetailsArray = detailsArray
                        ? detailsArray.filter(detail => {
                            const detailKey = Object.keys(detail)[0]; // Get the dynamic key
                            const countValue = detail[detailKey]?.count; // Get the count value
                            const valueAmount = detail[detailKey]?.value; // Get the value amount

                            // Include detail if it has either a non-zero count or explicitly defined zero values
                            return countValue !== undefined && valueAmount !== undefined;
                        })
                        : [];


                    // Return the processed item with all details included
                    return {
                        month,
                        year,
                        totalCount,
                        grandTotal,
                        details: filteredDetails,
                        detailsArray: filteredDetailsArray,
                        selectedRows: selectedRows
                    };
                });


                setGroupedTable(processedData)
            } catch (error) {
                props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
            }
            props.setLoading(false);
        } else {
            setSelectedValue(event.target.value);
            let locationData = selectedLocation?.map((el) => el._id)
            let expCenterData = selectedExperienceCenter?.map((el) => el._id)
            let obj = {
                startDate: storeDateFilter.startDate,
                endDate: storeDateFilter.endDate,
                selectedLocation: locationData ? locationData : "",
                selectedExperienceCenter: expCenterData ? expCenterData : "",
                userExpCenter: userDetails.selectedExpCenter,
                userLocation: userDetails.selectedLocation,
                tokenPercentage: event.target.value !== "" ? event.target.value : "",
                lost: selectLost !== "" ? selectLost : ""
            }
            props.setLoading(true);
            try {
                let users = ''
                if (selectedUsers && selectedUsers.length !== 0) {
                    users = selectedUsers?.map((el) => el._id)
                }
                obj.users = users ? users : ""
                obj.selectedRole = selectedRole
                let response = await HttpService.overallSummaryDashBoard(obj);
                setStore(response.data.data);
            } catch (error) {
                props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
            }
            props.setLoading(false);
        }
    }

    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }

    const handleSearch = async (value) => {
        if (dynamicDataShow !== 0) {
            overallSummaryDashBoardGroupWise(selectedLocation, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput, selectedGroup)
        } else {
            overallsummary(selectedLocation, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
        }

    }
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && selectedSearchType && searchInput) {
            handleSearch(searchInput.toUpperCase());
        }
    };
    // const handleSelctLost = async (event) => {
    //     setSeletLost(event.target.value)
    //     let expCenterData = selectedExperienceCenter?.map((el) => el._id)
    //     let obj = {
    //         startDate: storeDateFilter.startDate,
    //         endDate: storeDateFilter.endDate,
    //         selectedExperienceCenter: expCenterData ? expCenterData : "",
    //         tokenPercentage: selectedValue !== "" ? selectedValue : "",
    //         lost: event.target.value !== "" ? event.target.value : ''
    //     }
    //     props.setLoading(true);
    //     if (pivot === 'value' || pivot === 'total') {
    //         try {
    //             let users = ''
    //             if (selectedUsers && selectedUsers.length !== 0) {
    //                 users = selectedUsers?.map((el) => el._id)
    //             }
    //             obj.users = users ? users : ""
    //             obj.selectedRole = selectedRole
    //             obj.pivotValue = 'value'
    //             obj.userExpCenter = userDetails.selectedExpCenter
    //             let response = await HttpService.getSalesDataBasedOnExpCenter(obj);
    //             setStore(response.data);
    //         } catch (error) {
    //             props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
    //         }
    //     } else if (pivot === 'salesOverallReview') {
    //         try {
    //             let users = ''
    //             if (selectedUsers && selectedUsers.length !== 0) {
    //                 users = selectedUsers?.map((el) => el._id)
    //             }
    //             obj.users = users ? users : ""
    //             obj.selectedRole = selectedRole
    //             let response = await HttpService.getSalesDatoverallReviewDashBoard(obj);
    //             setStore(response.data);
    //         } catch (error) {
    //             props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
    //         }
    //     }
    //     props.setLoading(false);
    // }



    const handleSelectRoles = async (event, role) => {
        setSelectedUsers([])
        let obj = {}
        if (role) {
            obj.role = role
        } else {
            setSelectedRole(event.target.value)
            obj.role = event.target.value
        }
        obj.pivotValue = pivot
        try {
            let response = await HttpService.getSelectedUsersBasedOnRoles(obj);

            if (dynamicDataShow !== 0) {
                if (!role) {
                    await overallSummaryDashBoardGroupWise(selectedLocation, selectedExperienceCenter, obj, selectedSearchType, searchInput, selectedGroup)
                }
            } else {
                if (!role) {
                    await overallsummary(selectedLocation, selectedExperienceCenter, obj, selectedSearchType, searchInput)
                }
            }

            setUsersData(response.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
    }

    const fetchUsersData = async () => {
        let obj = {}
        if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            obj.role = ROLENAME.SalesUser
        } else if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            obj.role = ROLENAME.DesignUser
        } else {
            obj.role = "ALL"
        }
        try {
            let response = await HttpService.getSelectedUsersBasedOnRoles(obj);
            setUsersData(response.data)
        } catch (error) {
            console.log(error, "error")
        }
    }

    let storedd = ''

    const handleMultipleExpData = (e, newvalue) => {
        setSelectedExperienceCenter(newvalue)
        handleExpData(newvalue)
    }

    const handleMultipleLocationData = (e, newValue) => {
        setSelectedLocation(newValue)
        handleLocationData(newValue)
    }
    const handleLocationData = async (newvalue) => {
        props.setLoading(true);

        if (dynamicDataShow !== 0) {
            await overallSummaryDashBoardGroupWise(newvalue, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput, selectedGroup)
        } else {
            await overallsummary(newvalue, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
        }
        props.setLoading(false);
    }

    const handleMultipleUsers = (e, newvalue) => {
        setSelectedUsers(newvalue)
        handleUsersData(newvalue)
    }

    const handleUsersData = async (newvalue) => {
        props.setLoading(true);
        let obj = {
            users: newvalue,
            role: selectedRole
        }

        if (dynamicDataShow !== 0) {
            await overallSummaryDashBoardGroupWise(selectedLocation, selectedExperienceCenter, obj, selectedSearchType, searchInput, selectedGroup)
        } else {
            await overallsummary(selectedLocation, selectedExperienceCenter, obj, selectedSearchType, searchInput)
        }

        props.setLoading(false);
    }

    const dataBasedOnClick = async (e, ele, status) => {
        setStaus(status)
        let expCenterData = selectedExperienceCenter?.map((el) => el._id)
        let locationData =
            selectedLocation && selectedLocation.length > 0
                ? selectedLocation.map((el) => el._id)
                : "";
        let users = ''
        if (selectedUsers && selectedUsers.length !== 0) {
            users = selectedUsers?.map((el) => el._id)
        }
        let obj = {}
        if (dynamicDataShow !== 0) {

            obj = {
                status: status.includes('designHoldGrand')
                    ? status.replace('designHoldGrand', 'design-Hold')
                    : status.includes('designHold')
                        ? status.replace('designHold', 'design-Hold')
                        : status,

                _id: {
                    year: ele.year,
                    month: ele?.month
                },
                selectedRows: ele?.selectedRows,
                selectedExperienceCenter: expCenterData.length !== 0 ? expCenterData : "",
                selectedLocation: locationData.length !== 0 ? locationData : "",
                userExpCenter: userDetails.experienceCenterId,
                userLocation: userDetails.selectedLocation,
                tokenPercentage: selectedValue !== "" ? selectedValue : "",
                users: users ? users : "",
                searchType: selectedSearchType ? selectedSearchType : "",
                search: searchInput !== "" ? searchInput.toUpperCase() : "",
                groupId: selectedGroup
            }

        } else {
            obj = {
                status: status,
                _id: ele._id,
                selectedExperienceCenter: expCenterData.length !== 0 ? expCenterData : "",
                selectedLocation: locationData.length !== 0 ? locationData : "",
                userExpCenter: userDetails.experienceCenterId,
                userLocation: userDetails.selectedLocation,
                tokenPercentage: selectedValue !== "" ? selectedValue : "",
                users: users ? users : "",
                searchType: selectedSearchType ? selectedSearchType : "",
                search: searchInput !== "" ? searchInput.toUpperCase() : ""
            }
        }

        props.setLoading(true);
        obj.role = selectedRole
        if (status === 'total' && ele?._id?.year !== 'Grand Total') {
            obj.startDate = ''
            obj.endDate = ''
        }


        if (ele?._id?.year === 'Grand Total' && ele?._id?.month === 'Total') {
            obj.startDate = storeDateFilter.startDate
            obj.endDate = storeDateFilter.endDate
        }

        if (ele?.year === 'Grand Total' && ele?.month === 'Total') {
            obj.startDate = storeDateFilter.startDate
            obj.endDate = storeDateFilter.endDate
        }

        try {

            let response;
            if (dynamicDataShow !== 0) {
                response = await HttpService.getDataBasedClickOverallSummaryForDynamicDetails(obj);
            } else {
                response = await HttpService.getDataBasedClickOverallSummary(obj);
            }

            setPopMonthData(response.data)
            setShowDetailedModal(true)
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const [isGroupingMode, setIsGroupingMode] = useState(false);
    const [selectedRows, setSelectedRows] = useState({});
    const [selectedHeadings, setSelectedHeadings] = useState({});
    const [open, setOpen] = useState(false); // For controlling dialog open state
    const [groupName, setGroupName] = useState(''); // To store user name
    const [storeGroupDetails, setStoreGroupDetails] = useState([])

    const [selectedGroup, setSelectedGroup] = useState('');

    const dynamicGroupDetails = async () => {
        try {
            let res = await HttpService.dynamicGroupDetails();

            // Transform the response to get an array of objects with name and _id
            // Transform the response to get an array of objects with name, groupId, and mainId
            const transformedGroups = res.data.grouping.flatMap(grouping =>
                grouping.groups.map(group => ({
                    name: group.groupName,      // Use 'name' for groupName
                    _id: group._id,             // Use '_id' as is for the group ID
                    mainId: grouping._id        // Include the main document ID from the grouping
                }))
            );

            // Set the transformed data to state
            setStoreGroupDetails(transformedGroups);

        } catch (error) {
            props.setSnackInfo(error, "Something went wrong");
        }
    };

    useEffect(() => {
        dynamicGroupDetails();
    }, []);

    const handleToggleGroupingMode = () => {
        setIsGroupingMode(!isGroupingMode);
    };

    const handleClickOpen = () => {
        setOpen(true); // Open the dialog
        dynamicGroupDetails()
    };

    const handleClose = () => {
        setOpen(false); // Close the dialog
    };


    const handleHeadingSelect = (type, isChecked) => {
        setStoreHeadings((prevStoreHeadings) => {
            let updatedHeadings;

            if (isChecked) {
                // Add the new heading, ensuring no leading '/'
                updatedHeadings = prevStoreHeadings ? `${prevStoreHeadings}/${type}` : type;
            } else {
                // Remove the heading if it's unchecked
                const headingsArray = prevStoreHeadings.split('/');
                updatedHeadings = headingsArray
                    .filter(heading => heading !== type) // Remove unchecked heading
                    .join('/'); // Re-join without extra leading '/'
            }

            // Ensure no leading '/' if updatedHeadings is not empty
            return updatedHeadings.startsWith('/') ? updatedHeadings.slice(1) : updatedHeadings;
        });
    };



    const handleHeadingSelectForSubGroups = (type, isChecked) => {
        setSelectedHeadings((prevState) => {
            const updatedHeadings = { ...prevState };
            updatedHeadings[type] = isChecked;

            // Get the list of currently checked headings
            const checkedHeadings = Object.keys(updatedHeadings).filter((key) => updatedHeadings[key]);

            // Separate slash and non-slash headings
            const slashHeadings = checkedHeadings.filter((heading) => heading.includes('/'));
            const nonSlashHeadings = checkedHeadings.filter((heading) => !heading.includes('/'));

            // Initialize a variable to hold the concatenated heading result
            let concatenatedHeading = slashHeadings.length > 0 ? slashHeadings.join('/') : null;

            // Append non-slash headings to concatenated slash heading, if it exists
            if (concatenatedHeading && nonSlashHeadings.length > 0) {
                concatenatedHeading = `${concatenatedHeading}/${nonSlashHeadings.join('/')}`;
            } else if (!concatenatedHeading) {
                // If there are no slash headings, just use the non-slash headings
                concatenatedHeading = nonSlashHeadings.join('/');
            }

            // Prepare the final headings list
            let finalHeadings = [...storeHeadings];

            // Remove any existing slash-based headings from storeHeadings
            checkedHeadings.forEach((heading) => {
                const index = finalHeadings.indexOf(heading);
                if (index !== -1) {
                    finalHeadings.splice(index, 1);
                }
            });

            // Add the concatenated heading if it’s not already in finalHeadings
            if (concatenatedHeading && !finalHeadings.includes(concatenatedHeading)) {
                finalHeadings.push(concatenatedHeading);
            }

            // Handle unchecking logic by removing unchecked headings directly
            if (!isChecked) {
                const index = finalHeadings.indexOf(type);
                if (index !== -1) {
                    finalHeadings.splice(index, 1);
                }
            }

            // Update storeHeadings with the final list
            setStoreHeadings(finalHeadings);
            return updatedHeadings; // Return updated checked state
        });
    };




    const handleRowSelect = (month, year, checked) => {


        // Convert year to last two digits
        const formattedYear = year % 100; // Get last two digits of the year

        setSelectedRows((prev) => {
            const newSelectedRows = { ...prev };

            // Initialize the year if it doesn't exist
            if (!newSelectedRows[formattedYear]) {
                newSelectedRows[formattedYear] = new Set();
            }

            // Add or remove the month based on the `checked` state
            if (checked) {
                newSelectedRows[formattedYear].add(month);
            } else {
                newSelectedRows[formattedYear].delete(month);
                // If no months are selected for the year, remove the year entry
                if (newSelectedRows[formattedYear].size === 0) {
                    delete newSelectedRows[formattedYear];
                }
            }


            return newSelectedRows;
        });
    };

    const handleRowSelected = (inputString, checked) => {


        let formattedMonths = [];
        let newSelectedRows; // Declare the variable here

        // Check for the presence of '-'
        if (inputString.includes('-')) {
            const [monthYear, fullYear] = inputString.split('-'); // Split at the last '-'
            const months = monthYear.split('/'); // Split months by '/'

            // Convert year to last two digits
            const formattedYear = fullYear ? (parseInt(fullYear) % 100).toString().padStart(2, '0') : '';
            formattedMonths = months.map(month => `${month}-${formattedYear}`); // Format months as "month-year"
        } else {
            const [month, year] = inputString.split('/');
            const formattedYear = (parseInt(year) % 100).toString().padStart(2, '0'); // Convert to last two digits
            formattedMonths = [`${month}-${formattedYear}`]; // Format it as "month-year"
        }

        // Update selected rows
        setSelectedRows(prev => {
            newSelectedRows = { ...prev }; // Clone previous state

            // Create a set to store all formatted entries in selectedRows
            const existingSelections = new Set();
            Object.values(prev).forEach(monthSet => {
                monthSet.forEach(month => {
                    existingSelections.add(month);
                });
            });

            // If checked, add the formatted months to selectedRows
            if (checked) {
                const groupKey = formattedMonths.join('/'); // Create a group key

                // Only add the entire group if it's not already present
                if (!existingSelections.has(groupKey)) {
                    const year = formattedMonths[0].split('-')[1]; // Extract year from the first month
                    if (!newSelectedRows[year]) {
                        newSelectedRows[year] = new Set();
                    }
                    newSelectedRows[year].add(groupKey); // Add the group key
                }
            } else {
                // If unchecked, remove the formatted months
                const groupKey = formattedMonths.join('/'); // Create a group key for removal
                const year = formattedMonths[0].split('-')[1]; // Extract year
                newSelectedRows[year]?.delete(groupKey); // Remove the group key

                // If no groups are selected for the year, remove the year entry
                if (newSelectedRows[year] && newSelectedRows[year].size === 0) {
                    delete newSelectedRows[year];
                }
            }


            return newSelectedRows;
        });

        // Update storeRowsData using the new selected rows
        setStoreRowsData(prevStored => {
            // Format the selected rows into a concatenated string
            const newRow = formatSelectedRowsed(newSelectedRows);
            if (newRow) {
                // First, filter out existing entries that are substrings of newRow
                const filteredPrevStored = prevStored.filter(row => !newRow.includes(row));

                // Remove any entries from prevStored that are smaller than newRow
                const finalFilteredPrevStored = filteredPrevStored.filter(row => {
                    const rowParts = row.split('/');
                    return !newRow.split('/').some(newRowPart => rowParts.includes(newRowPart));
                });

                // If newRow is not already present in finalFilteredPrevStored, add it to the list
                if (!finalFilteredPrevStored.includes(newRow)) {
                    return [...finalFilteredPrevStored, newRow]; // Append new concatenated row
                }
            }

            return prevStored; // Return unchanged state if newRow is empty or duplicate
        });

    };

    // Helper to format selected rows as "1-24/2-24/3-24/4-24"
    const formatSelectedRows = (selectedRows) => {

        const formattedArray = [];

        // Iterate through each year in selectedRows
        Object.entries(selectedRows).forEach(([year, months]) => {
            // Format each month for the current year
            months.forEach(month => {
                // Create formatted month-year pair
                formattedArray.push(`${month}-${year}`);
            });
        });

        // Join all formatted strings with a slash
        return formattedArray.join('/'); // Return in the required format
    };

    const formatSelectedRowsed = (selectedRows) => {

        const formattedArray = [];

        // Iterate through each year in selectedRows
        Object.entries(selectedRows).forEach(([year, groups]) => {
            groups.forEach(group => {
                // Directly push the group as is (already formatted)
                formattedArray.push(group);
            });
        });


        // Join all formatted strings with a slash
        return formattedArray.join('/'); // Return in the required format
    };



    const filterUniqueHeadings = (headings) => {
        // Split each heading by '/' into parts
        const splitHeadings = headings.map(heading => heading.split('/'));

        // Filter out headings that are already part of a larger heading
        return splitHeadings
            .filter((heading, index, arr) => {
                // For each heading, check if it is part of any larger heading
                return !arr.some((otherHeading, otherIndex) => {
                    // Ensure we're not comparing the same heading with itself
                    if (otherIndex !== index) {
                        // Check if current heading is part of another heading (larger one)
                        return otherHeading.join('/') !== heading.join('/') && otherHeading.join('/').includes(heading.join('/'));
                    }
                    return false;
                });
            })
            .map(heading => heading.join('/')); // Join back the split headings to get the full headings
    };

    const handleSubmit = async () => {
        // Check if storeHeadings is a single string or an array
        const selectedHeadingsArray = typeof storeHeadings === 'string'
            ? [storeHeadings]  // If single string, wrap it in an array without filtering
            : filterUniqueHeadings(storeHeadings);  // If array, filter it


        // return;

        // Prepare the payload with the modified selected headings
        const selectedData = {
            groups: [
                {
                    groupName: groupName,
                    selectedHeadings: [...new Set(selectedHeadingsArray)], // Ensure uniqueness
                    selectedRows: storeRowsData.length > 0 ? storeRowsData : formatSelectedRows(selectedRows),
                    formCategoryName: 'design-summary'
                },
            ],
        };

        // Send the API request and handle the response
        try {
            const response = await HttpService.dynamicGroupingUserWise(selectedData);

            props.setSnackInfo(response.data.message, "success");
            setGroupName('');
            setSelectedHeadings({});
            setSelectedRows({});
            setIsGroupingMode(false);
            dynamicGroupDetails();
            handleClose(); // Close the dialog after successful API call
        } catch (error) {
            props.setSnackInfo(error?.error ?? "Group Limit Exhausted", "error");
            setGroupName('');
            setSelectedHeadings({});
            setSelectedRows({});
            setIsGroupingMode(false);
            dynamicGroupDetails();
            handleClose();
        }
    };



    const clearDateFilter = async () => {
        setSearchInput("")
        setSelectedSearchType("")
        dispatch(setOverAllDesignSummary(null))
        setShouldRefresh(true) // Trigger the useEffect
        overallsummary(selectedLocation, selectedExperienceCenter, selectedUsers, "", "")
        if (dynamicDataShow !== 0) {
            await overallSummaryDashBoardGroupWise(null, null, null, null, null, selectedGroup)
        }
    }

    useEffect(() => {
        // Check if there's a stored disable time in localStorage
        const disableUntilTimestamp = localStorage.getItem(THIRD_BUTTON_DISABLE_UNTIL_KEY);
        
        if (disableUntilTimestamp) {
            const now = new Date().getTime();
            const disableUntil = parseInt(disableUntilTimestamp, 10);
            
            // If the disable time is in the future, calculate remaining time
            if (disableUntil > now) {
            const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
            setTimeLeft(remainingTimeInSeconds);
            setIsDisabled(true);
            } else {
            // If the time has passed, clear localStorage
            localStorage.removeItem(THIRD_BUTTON_DISABLE_UNTIL_KEY);
            setIsDisabled(false);
            setTimeLeft(0);
            }
        }
        
        // Set up timer to update remaining time
        let timer;
        if (isDisabled && timeLeft > 0) {
            timer = setInterval(() => {
            setTimeLeft(prevTime => {
                const newTime = prevTime - 1;
                if (newTime <= 0) {
                // When time is up, clear localStorage and enable button
                localStorage.removeItem(THIRD_BUTTON_DISABLE_UNTIL_KEY);
                setIsDisabled(false);
                return 0;
                }
                return newTime;
            });
            }, 1000);
        }
        
        return () => clearInterval(timer);
        }, [isDisabled, timeLeft]);
    
        useEffect(() => {
            if (shouldRefresh && designData === null) {
                overallsummary(selectedLocation, selectedExperienceCenter, selectedUsers, "", "")
                setShouldRefresh(false)
            }
        }, [designData, shouldRefresh])
    
        // Format time for display
        const formatTimeLeft = () => {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        };
    
        // Replace your existing handleRefreshClick with this
        const handleRefreshClick = () => {
        // Calculate the timestamp 4 minutes from now
        const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);
        
        // Store the timestamp in localStorage
        localStorage.setItem(THIRD_BUTTON_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());
        
        // Disable the button for 4 minutes
        setIsDisabled(true);
        setTimeLeft(10); // 4 minutes in seconds
        
        // Run the original functionality
        setIsSpinning(true);
        clearDateFilter();
        setTimeout(() => {
            setIsSpinning(false);
        }, 1000);
        };
    


    const handleGroupChange = (event, value) => {
        if (value) {

            setSelectedHeadings([])
            setUserGroupDetails(value);
            storeId(value?.mainId); // Pass the group ID directly to storeId
            setSelectedExperienceCenter([])
            setPivotDatefilters({ startDate: "", endDate: "" })
            setSelectedValue("")
            setSelectedUsers([])
            setSelectedSearchType("")
            setSearchInput("")
        }
    };

    let storeGroup = ''
    const storeId = (groupId) => {


        // Pass the groupId to the function that needs it
        storeGroup = groupId;
        setSelectedGroup(storeGroup)

        overallSummaryDashBoardGroupWise(null, null, null, null, null, storeGroup);
    };


    const overallSummaryDashBoardGroupWise = async (addLocation, addExpCenter, usersData, selectedSearchType, searchInput, groupId) => {
        let locationData = addLocation?.map((el) => el._id)
        let expCenterData = addExpCenter?.map((el) => el._id)

        let users = ''
        if ((usersData?.users && usersData?.users.length !== 0) || (selectedUsers && selectedUsers.length !== 0)) {
            users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id)
        }
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            selectedLocation: locationData ? locationData : "",
            tokenPercentage: selectedValue !== "" ? selectedValue : "",
            users: users ? users : "",
            // selectedRole: usersData?.role ? usersData?.role : ROLENAME.DesignUser,
            userExpCenter: userDetails.experienceCenterId,
            userLocation: userDetails.selectedLocation,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : "",
            groupId: groupId
        }
        if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.DesignUser
        } else if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.SalesUser
        } else {
            obj.selectedRole = usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL")
        }
        props.setLoading(true);
        try {
            let response = await HttpService.overallSummaryDashBoardGroupWise(obj);


            setDynamicDataShow((prev) => prev + 1)

            if (!response.data || !response.data.organizedData || !response.data.organizedData.data) {
                console.error("Invalid response structure", response.data);
                return;
            }

            const organizedData = response.data.organizedData.data;


            const processedData = organizedData.map(item => {
                const { totalCount, grandTotal, month, year, details,
                    selectedRows, detailsArray } = item;

                // Step 1: Extract details by filtering out keys that contain 'count'
                const filteredDetails = [];
                if (details) {
                    for (const [key, value] of Object.entries(details)) {
                        if (!key.toLowerCase().includes("count")) {
                            filteredDetails.push({ [key]: value });
                        }
                    }
                }

                // Step 2: Extract headings that include '/' in `detailsArray`
                // Create a Set to store unique headings containing '/'
                // Initialize a Set to store unique headings temporarily
                const uniqueHeadingsSet = new Set();

                if (detailsArray && detailsArray.length > 0) {
                    detailsArray.forEach(detail => {
                        Object.keys(detail).forEach(detailKey => {
                            if (detailKey.includes('/')) {
                                uniqueHeadingsSet.add(detailKey); // Add to Set to ensure uniqueness
                            }
                        });
                    });
                }

                // Convert Set to Array for new headings only
                const filteredHeadings = Array.from(uniqueHeadingsSet);

                // Conditionally update `storeHeadings` to add only new unique headings
                setStoreHeadings((prevStoreHeadings) => {
                    // Create a combined set to avoid duplicates
                    const newUniqueHeadings = new Set([...prevStoreHeadings, ...filteredHeadings]);

                    // Convert to array for consistency and to avoid re-renders due to reference change
                    const updatedHeadingsArray = Array.from(newUniqueHeadings);
                    return updatedHeadingsArray;
                });


                //   let  filteredMonths ;

                const filteredMonths = [];

                // Check if `month` is a string and contains '/'
                if (selectedRows && selectedRows.length > 0) {
                    // Concatenate selected rows using '/'
                    const concatenatedRows = selectedRows.join('/'); // e.g., '1-23/2-24'



                    // Update storeRowsData
                    setStoreRowsData(prevStored => {
                        // Check if the concatenated row already exists
                        if (!prevStored.includes(concatenatedRows)) {
                            return [...prevStored, concatenatedRows]; // Add new concatenated row if it doesn't exist
                        }
                        return prevStored; // Return unchanged state if it exists
                    });
                }


                // Collect headings in `setStoreHeadings`


                // Step 3: Filter `detailsArray` items that have either a non-zero count or explicitly defined zero values
                const filteredDetailsArray = detailsArray
                    ? detailsArray.filter(detail => {
                        const detailKey = Object.keys(detail)[0]; // Get the dynamic key
                        const countValue = detail[detailKey]?.count; // Get the count value
                        const valueAmount = detail[detailKey]?.value; // Get the value amount

                        // Include detail if it has either a non-zero count or explicitly defined zero values
                        return countValue !== undefined && valueAmount !== undefined;
                    })
                    : [];


                // Return the processed item with all details included
                return {
                    month,
                    year,
                    totalCount,
                    grandTotal,
                    details: filteredDetails,
                    detailsArray: filteredDetailsArray,
                    selectedRows: selectedRows
                };
            });

            setGroupedTable(processedData);

            setShowNewTable(true);

            // Array to store the headings

            // setStore(response.data.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }






    const handleExpData = async (newvalue) => {
        props.setLoading(true);

        if (dynamicDataShow !== 0) {
            await overallSummaryDashBoardGroupWise(selectedLocation, newvalue, selectedUsers, selectedSearchType, searchInput, selectedGroup)
        } else {
            await overallsummary(selectedLocation, newvalue, selectedUsers, selectedSearchType, searchInput)
        }
        props.setLoading(false);
    }

    const handleDelete = async (groupId, mainId) => {
        try {
            await HttpService.dynamicDeleteGroup(groupId, mainId); // Call the delete API
            // Remove the group from the frontend state
            setStoreGroupDetails((prevDetails) => prevDetails.filter(item => item._id !== groupId));
            dynamicGroupDetails()
        } catch (error) {
            console.error('Error deleting group:', error);
        }
    };


    const defaultView = () => {
        setShowNewTable(false);
        setUserGroupDetails([])
        setSelectedExperienceCenter([])
        setPivotDatefilters({ startDate: "", endDate: "" })
        setSelectedValue("")
        setSelectedUsers([])
        setSelectedSearchType("")
        setGroupedTable([])
        setSearchInput("")
        setStoreHeadings([])
        setDynamicDataShow(0)
        setStoreRowsData([])
    }
    useEffect(() => {
        dynamicGroupDetails()
    }, [showNewTable])
    return (
        <div className="App">
            <br />

            <div>


                <Paper className={classes.paper}>
                    <Grid
                        container
                        spacing={2}
                        justifyContent={
                            userDetails?.roles && userDetails.roles.some(role =>
                                [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.OperationDesignManager, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser, ROLENAME.DGM_Sales].includes(role.name)
                            )
                                ? "flex-start"
                                : "center"
                        }
                        alignItems="center"
                        wrap="nowrap"  // Prevents wrapping to the next line, keeps everything in one row
                    >
                        <Grid item xs={12} sm={3}>
                            <FormControl style={{ width: '100%', marginTop: '0.4rem' }}>
                                <Autocomplete
                                    options={storeGroupDetails}
                                    value={storeUserGroupDetails}
                                    getOptionLabel={(option) => option?.name || ''}
                                    onChange={handleGroupChange}
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                            <span style={{ flexGrow: 1 }}>{option?.name || ''}</span>
                                            {/* Add delete button */}
                                            <IconButton
                                                edge="end"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDelete(option);
                                                }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </React.Fragment>
                                    )}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select a Group" variant="outlined" />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        {userDetails?.roles &&
                            userDetails.roles.some((role) =>
                                [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.OperationDesignManager, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser, ROLENAME.DGM_Sales,ROLENAME.FinanceUser,ROLENAME.FinanceManager,ROLENAME.FinanceExecutive].includes(role.name)
                            ) && (
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedLocation}
                                            onChange={handleMultipleLocationData}
                                            options={commonLocation}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Location"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            )}
                        {userDetails?.roles &&
                            userDetails.roles.some((role) =>
                                [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.OperationDesignManager, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser, ROLENAME.DGM_Sales,ROLENAME.FinanceUser,ROLENAME.FinanceManager,ROLENAME.FinanceExecutive].includes(role.name)
                            ) && (
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%', marginTop: '0.4rem' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedExperienceCenter}
                                            onChange={handleMultipleExpData}
                                            options={commonExpCenter}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Exp-Center"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            )}
                        <Grid item xs={12} sm={2}>
                            <TextField
                                id="startDate"
                                name="startDate"
                                label="From Date"
                                type="date"
                                variant="outlined"
                                value={storeDateFilter.startDate}
                                onChange={storePivotDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                id="endDate"
                                name="endDate"
                                label="End Date"
                                type="date"
                                variant="outlined"
                                value={storeDateFilter.endDate}
                                onChange={storePivotDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handlePivotDateFilter}
                                style={{
                                    backgroundColor: "#F50057",
                                    color: "#fff",
                                    padding: "0.4rem 2rem 2rem 2rem",
                                }}
                                className={classes.submitButton}
                            >
                                Submit
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={12} sm={2}>
                            <FormControl style={{ width: '70%', marginTop: "0.4rem" }}>
                                <TextField
                                    select
                                    labelId="project-doc"
                                    label="5 % Payment"
                                    variant="outlined"
                                    value={selectedValue}
                                    onChange={(e) => handleSelectChange(e)}
                                >
                                    <MenuItem value="2">All</MenuItem>
                                    <MenuItem value="1">YES</MenuItem>
                                    <MenuItem value="0">NO</MenuItem>
                                </TextField>
                            </FormControl>
                        </Grid>

                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.DGM_Sales].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRole}
                                            onChange={(e) => handleSelectRoles(e)}
                                        // disabled={pivot === "lost" && !selectedDepartment}  // Disable if selectedDepartment is not set and pivot is "lost"
                                        >
                                            {/* Create an array of MenuItem elements instead of using a fragment */}
                                            {[
                                                <MenuItem key="ALL" value="ALL">ALL</MenuItem>,
                                                ...(userDetails.departmentId === salesDepartment ? [
                                                    <MenuItem key={ROLENAME.DGM_Sales} value={ROLENAME.DGM_Sales}>DGM Sales</MenuItem>,
                                                    <MenuItem key={ROLENAME.SalesManager} value={ROLENAME.SalesManager}>Sales Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.AssistantSalesManager} value={ROLENAME.AssistantSalesManager}>Assistant Sales Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.SalesUser} value={ROLENAME.SalesUser}>Executive</MenuItem>
                                                ] : [
                                                    <MenuItem key={ROLENAME.DGM_Design} value={ROLENAME.DGM_Design}>DGM Design</MenuItem>,
                                                    <MenuItem key={ROLENAME.OperationDesignManager} value={ROLENAME.OperationDesignManager}>Operation Design Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.AssistantDesignManager} value={ROLENAME.AssistantDesignManager}>Assistant Design Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.DesignUser} value={ROLENAME.DesignUser}>Designer</MenuItem>
                                                ])
                                            ]}
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedUsers}
                                            onChange={(e, v) => handleMultipleUsers(e, v)}
                                            options={usersData}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}

                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.SalesManager, ROLENAME.OperationDesignManager].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRole}
                                            onChange={(e) => handleSelectRoles(e)}
                                        // disabled={pivot === "lost" && !selectedDepartment}  // Disable if selectedDepartment is not set and pivot is "lost"
                                        >
                                            {/* Create an array of MenuItem elements instead of using a fragment */}
                                            {[
                                                ...(userDetails.departmentId === salesDepartment ? [
                                                    <MenuItem key={ROLENAME.SalesManager} value={ROLENAME.SalesManager}>Sales Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.AssistantSalesManager} value={ROLENAME.AssistantSalesManager}>Assistant Sales Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.SalesUser} value={ROLENAME.SalesUser}>Executive</MenuItem>
                                                ] : [
                                                    <MenuItem key={ROLENAME.OperationDesignManager} value={ROLENAME.OperationDesignManager}>Operation Design Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.AssistantDesignManager} value={ROLENAME.AssistantDesignManager}>Assistant Design Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.DesignUser} value={ROLENAME.DesignUser}>Designer</MenuItem>
                                                ])
                                            ]}
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedUsers}
                                            onChange={(e, v) => handleMultipleUsers(e, v)}
                                            options={usersData}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}

                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.AssistantSalesManager, ROLENAME.AssistantDesignManager].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRole}
                                            onChange={(e) => handleSelectRoles(e)}
                                        // disabled={pivot === "lost" && !selectedDepartment}  // Disable if selectedDepartment is not set and pivot is "lost"
                                        >
                                            {/* Create an array of MenuItem elements instead of using a fragment */}
                                            {[
                                                ...(userDetails.departmentId === salesDepartment ? [
                                                    <MenuItem key={ROLENAME.AssistantSalesManager} value={ROLENAME.AssistantSalesManager}>Assistant Sales Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.SalesUser} value={ROLENAME.SalesUser}>Executive</MenuItem>
                                                ] : [
                                                    <MenuItem key={ROLENAME.AssistantDesignManager} value={ROLENAME.AssistantDesignManager}>Assistant Design Manager</MenuItem>,
                                                    <MenuItem key={ROLENAME.DesignUser} value={ROLENAME.DesignUser}>Designer</MenuItem>
                                                ])
                                            ]}
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            size="medium"
                                            value={selectedUsers}
                                            onChange={(e, v) => handleMultipleUsers(e, v)}
                                            ListboxProps={{ style: { maxHeight: "15rem" }, position: "bottom-start" }}
                                            options={usersData}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}
                        <Grid item xs={12} sm={3}>
                            <FormControl style={{ marginTop: '0.30rem' }}>
                                <Button variant="contained" color="primary" onClick={defaultView} style={{ backgroundColor: "#F47E46", color: "#FFF2EB", padding: "0.4rem 2rem 2rem 2rem" }}>
                                    Default Table</Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '30px' }}>
                        {/* Search Type Dropdown */}
                        <TextField
                            select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedSearchType}
                            label="Search Type"
                            name="searchType"
                            onChange={(e) => handleSearchType(e.target.value)}
                            variant="outlined"
                            style={{ width: '30%', marginRight: '2%' }}
                            size="small"
                        >
                            {searchTypes && searchTypes?.map((el, index) => (
                                <MenuItem key={index} value={el}>{el}</MenuItem>
                            ))}
                        </TextField>

                        {/* Search Input */}
                        <TextField
                            label="Enter the input"
                            name="searched"
                            size="small"
                            value={searchInput}
                            onChange={(e) => { setSearchInput(e.target.value) }}
                            onKeyDown={handleKeyDown}  // Listening for the "Enter" key press
                            variant="outlined"
                            style={{ width: '80%' }}
                        />

                        {/* Search Button */}
                        <Button
                            disabled={!selectedSearchType || !searchInput}
                            variant="contained"
                            color="primary"
                            size="medium"
                            style={{ alignSelf: "center", marginLeft: 20 }}
                            className={classes.leadSearchButton}
                            onClick={() => handleSearch(searchInput.toUpperCase())}
                        >
                            Search
                        </Button>

                        {/* Clear Filter Button */}
                        <Button
                            variant="contained"
                            color="secondary"
                            size="medium"
                            style={{ marginLeft: 10 }}
                            className={classes.leadClearButton}
                            onClick={clearDateFilter}
                        >
                            Clear Filter
                        </Button>
                    </div>
                </Paper>
            </div>
            <br />


            <div>

                <>
                    <Box
                        display="flex"
                        alignItems="center"
                        mt={2}
                        backgroundColor="#3F51B5"
                        p={2} // padding inside the Box component

                    >
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleToggleGroupingMode}
                            style={{
                                marginRight: '8px',
                                padding: "0.4rem 2rem 2rem 2rem",
                                backgroundColor: "#F47E46",
                                color: "#FFF2EB",
                            }}
                        >
                            {isGroupingMode ? 'Cancel Grouping' : 'Create Group'}
                        </Button>
                        <Grid item>
                            <Button
                                onClick={handleRefreshClick}
                                variant="contained"
                                disabled={isDisabled}
                                style={{ 
                                backgroundColor: isDisabled ? "#cccccc" : "#F47E46", 
                                padding: "0.4rem 2rem 2rem 2rem",
                                color: "#FFF2EB",
                               
                                }}
                            >
                                {isDisabled 
                                ? `Wait (${formatTimeLeft()})` 
                                : "Fetch New Data"}
                            </Button>
                        </Grid>


                        {isGroupingMode && (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleClickOpen}
                                style={{
                                    color: 'white', // white font color
                                    backgroundColor: '#3F51B5',
                                    padding: "0.4rem 2rem 2rem 2rem"
                                }}
                                className={classes.submitButton}
                            >
                                Submit Table
                            </Button>
                        )}
                    </Box>

                    {/* Dialog Box */}
                    <Dialog open={open} onClose={handleClose}>
                        <DialogTitle>Enter Group Name</DialogTitle>
                        <DialogContent>
                            <TextField
                                autoFocus
                                margin="dense"
                                label="Enter Group Name"
                                type="text"
                                fullWidth
                                value={groupName}
                                onChange={(e) => setGroupName(e.target.value)}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose} color="secondary">
                                Cancel
                            </Button>
                            <Button onClick={handleSubmit} color="primary">
                                Submit
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>


                {!showNewTable ? (
                    <>
                        <div style={{ maxHeight: '600px', overflow: 'auto' }}>
                            <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '30px' }}>
                                <Table style={{ minWidth: '600px' }}>
                                    <TableHead style={{ position: 'sticky', top: 0, zIndex: 9, background: 'white' }}>
                                        <StyledTableRow>
                                            {
                                                <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }} rowSpan={2}>Month And Year</StyledTableCell>
                                            }
                                            <StyledTableCell colSpan={2} className={classes.bordercolors} style={{ textAlign: 'center' }}>Designer Not Assigned Pending With Sales {isGroupingMode && <Checkbox onChange={(e) => handleHeadingSelect('designerNotAssignedPendingWithSales', e.target.checked)} />}</StyledTableCell>
                                            <StyledTableCell colSpan={2} className={classes.bordercolors} style={{ textAlign: 'center' }}>Designer Not Assigned KOM Rejected {isGroupingMode && <Checkbox onChange={(e) => handleHeadingSelect('designerNotAssignedKOMRejected', e.target.checked)} />}</StyledTableCell>
                                            <StyledTableCell colSpan={2} className={classes.bordercolors} style={{ textAlign: 'center' }}>Designer Not Assigned - Pending with Design {isGroupingMode && <Checkbox onChange={(e) => handleHeadingSelect('designerNotAssignedPendingWithDesign', e.target.checked)} />}</StyledTableCell>
                                            <StyledTableCell colSpan={2} className={classes.bordercolors} style={{ textAlign: 'center' }}>Design KickOff Internal {isGroupingMode && <Checkbox onChange={(e) => handleHeadingSelect('designKickOffInternal', e.target.checked)} />}</StyledTableCell>
                                            <StyledTableCell colSpan={2} className={classes.bordercolors} style={{ textAlign: 'center' }}>Design KickOff Customer {isGroupingMode && <Checkbox onChange={(e) => handleHeadingSelect('designKickOffCustomer', e.target.checked)} />}</StyledTableCell>
                                            <StyledTableCell colSpan={2} className={classes.bordercolors} style={{ textAlign: 'center' }}>Design {isGroupingMode && <Checkbox onChange={(e) => handleHeadingSelect('design', e.target.checked)} />}</StyledTableCell>
                                            <StyledTableCell colSpan={2} className={classes.bordercolors} style={{ textAlign: 'center' }}>Design-Hold {isGroupingMode && <Checkbox onChange={(e) => handleHeadingSelect('designHoldGrand', e.target.checked)} />}</StyledTableCell>
                                            <StyledTableCell colSpan={2} className={classes.bordercolors} style={{ textAlign: 'center' }}>Completed {isGroupingMode && <Checkbox onChange={(e) => handleHeadingSelect('completed', e.target.checked)} />}</StyledTableCell>
                                            <StyledTableCell colSpan={2} className={classes.bordercolors} style={{ textAlign: 'center' }}>Lost {isGroupingMode && <Checkbox onChange={(e) => handleHeadingSelect('lost', e.target.checked)} />}</StyledTableCell>
                                            <StyledTableCell colSpan={2} className={classes.bordercolors} style={{
                                                fontSize: '15px',
                                                textAlign: 'center'
                                            }}>Grand Total</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell className={classes.bordercolors}>Count</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Value</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Count</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Value</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Count</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Value</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Count</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Value</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Count</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Value</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Count</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Value</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Count</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Value</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Count</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Value</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Count</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Value</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Count</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors}>Value</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableHead style={{ position: 'sticky', top: 0, background: 'white' }}>
                                        {store.map((ele, index) => (
                                            <StyledTableRow key={index}>
                                                {
                                                    <>
                                                        {index === store.length - 1 ?
                                                            <StyledTableCell className={classes.bordercolors} style={{
                                                                fontSize: index === store.length - 1 ? '15px' : '13px',
                                                                fontWeight: index === store.length - 1 ? 'bolder' : 'normal',
                                                                left: 0,
                                                                position: 'sticky',
                                                                textAlign: 'center'
                                                            }}>{ele?._id?.year}</StyledTableCell> :
                                                            <StyledTableCell className={classes.bordercolors} style={{
                                                                fontSize: index === store.length - 1 ? '15px' : '13px',
                                                                fontWeight: index === store.length - 1 ? 'bolder' : 'normal',
                                                                left: 0,
                                                                position: 'sticky',
                                                                textAlign: "center"
                                                            }}>
                                                                {months[ele?.month]}-{ele?._id?.year % 100}
                                                                {isGroupingMode &&
                                                                    <Checkbox
                                                                        onChange={(e) =>
                                                                            handleRowSelect(
                                                                                `${ele?._id?.month}`, // month as a string
                                                                                ele?._id?.year,      // full year as number
                                                                                e.target.checked      // checked status
                                                                            )
                                                                        }
                                                                    />
                                                                }

                                                                {/* {ele?.month}/{ele?._id?.year % 100} */}
                                                            </StyledTableCell>
                                                        }
                                                    </>
                                                }

                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={(e) => dataBasedOnClick(e, ele, "designerNotAssignedPendingWithSales")}>{ele.designerNotAssignedPendingWithSalesCount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={(e) => dataBasedOnClick(e, ele, "designerNotAssignedPendingWithSales")}>{(ele.designerNotAssignedPendingWithSales)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={(e) => dataBasedOnClick(e, ele, "designerNotAssignedKOMRejected")}>{ele.designerNotAssignedKOMRejectedCount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={(e) => dataBasedOnClick(e, ele, "designerNotAssignedKOMRejected")}>{(ele.designerNotAssignedKOMRejected)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={(e) => dataBasedOnClick(e, ele, "designerNotAssignedPendingWithDesign")}>{(ele.designerNotAssignedPendingWithDesignCount)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={(e) => dataBasedOnClick(e, ele, "designerNotAssignedPendingWithDesign")}>{(ele.designerNotAssignedPendingWithDesign)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={(e) => dataBasedOnClick(e, ele, "designKickOffInternal")}>{(ele.designKickOffInternalCount)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={(e) => dataBasedOnClick(e, ele, "designKickOffInternal")}>{(ele.designKickOffInternal)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={(e) => dataBasedOnClick(e, ele, "designKickOffCustomer")}>{(ele.designKickOffCustomerCount)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={(e) => dataBasedOnClick(e, ele, "designKickOffCustomer")}>{(ele.designKickOffCustomer)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={(e) => dataBasedOnClick(e, ele, "design")}>{ele.designCount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={(e) => dataBasedOnClick(e, ele, "design")}>{(ele.design)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={(e) => dataBasedOnClick(e, ele, "design-Hold")}>{ele.designHoldcount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={(e) => dataBasedOnClick(e, ele, "design-Hold")}>{(ele.designHoldGrand)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={(e) => dataBasedOnClick(e, ele, "completed")}>{ele.completedCount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={(e) => dataBasedOnClick(e, ele, "completed")}>{(ele.completed)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={(e) => dataBasedOnClick(e, ele, "lost")}>{ele.lostcount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={(e) => dataBasedOnClick(e, ele, "lost")}>{(ele.lost)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: "#004d40", textDecoration: "underline", fontWeight: 'bolder', background: "white", textAlign: "center" }} onClick={(e) => dataBasedOnClick(e, ele, "total")}>{ele?.totalCount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: "#004d40", textDecoration: "underline", fontWeight: 'bolder', background: "white", textAlign: "center" }} onClick={(e) => dataBasedOnClick(e, ele, "total")}>{(ele?.grandTotal)?.toFixed(2)}</StyledTableCell>

                                            </StyledTableRow>
                                        ))}
                                    </TableHead>
                                </Table>
                            </TableContainer>
                        </div>

                    </>)
                    :
                    <div style={{ maxHeight: '600px', overflow: 'auto' }}>
                        <TableContainer component={Paper} className={classes.customTableContainer} style={{ marginTop: '30px' }}>
                            <Table style={{ minWidth: '600px' }}>
                                <TableHead style={{ position: 'sticky', top: 0, zIndex: 9, background: 'white' }}>
                                    <TableRow>
                                        <TableCell
                                            className={classes.bordercolors}
                                            rowSpan={2}
                                            style={{ textAlign: "center", position: 'sticky', left: 0, zIndex: 9, background: '#3F51B5', color: 'white' }}>
                                            Month And Year
                                        </TableCell>

                                        {/* Dynamically create headers for details */}
                                        {groupedTable[0]?.detailsArray?.map((detail, index) => {
                                            const detailKey = Object.keys(detail)[0]; // Get the key of the current detail
                                            const isChecked = selectedHeadings[detailKey] || false; // Check if the heading is selected

                                            // Format the detailKey
                                            let formattedDetailKey = detailKey
                                                .replace('designHoldGrand', 'Design Hold') // Replace 'designHoldGrand' with 'Design Hold'
                                                .replace(/([A-Z])/g, ' $1') // Add space before each uppercase letter
                                                .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter

                                            return (
                                                <TableCell
                                                    key={index}
                                                    colSpan={2}
                                                    className={classes.bordercolors}
                                                    style={{ textAlign: 'center', background: '#3F51B5', color: 'white' }}
                                                >
                                                    {/* Display the formatted heading text */}
                                                    {formattedDetailKey}

                                                    {/* Conditionally render a checkbox if grouping mode is active */}
                                                    {isGroupingMode && (
                                                        <Checkbox
                                                            checked={isChecked}
                                                            onChange={(e) => handleHeadingSelectForSubGroups(detailKey, e.target.checked)}
                                                        />
                                                    )}
                                                </TableCell>
                                            );
                                        })}


                                        <TableCell colSpan={2} className={classes.bordercolors} style={{ textAlign: 'center', background: '#3F51B5', color: 'white' }}>Grand Total</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        {groupedTable[0]?.detailsArray?.map((_, index) => (
                                            <React.Fragment key={index}>
                                                <TableCell className={classes.bordercolors} style={{ background: '#3F51B5', color: 'white', textAlign: 'center' }}>Count</TableCell>
                                                <TableCell className={classes.bordercolors} style={{ background: '#3F51B5', color: 'white', textAlign: 'center' }}>Value</TableCell>
                                            </React.Fragment>
                                        ))}
                                        <TableCell className={classes.bordercolors} style={{ background: '#3F51B5', color: 'white', textAlign: 'center' }}>Count</TableCell>
                                        <TableCell className={classes.bordercolors} style={{ background: '#3F51B5', color: 'white', textAlign: 'center' }}>Value</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {groupedTable.map((ele, rowIndex) => (
                                        ele?.month !== 13 && (
                                            <>
                                                <TableRow key={rowIndex}>
                                                    <TableCell
                                                        className={classes.bordercolors}
                                                        style={{ textAlign: "center", position: 'sticky', left: 0, background: '#3F51B5', color: 'white' }}
                                                    >
                                                        {displayDate(ele?.month, ele?.year, ele?.selectedRows)}
                                                        {isGroupingMode &&
                                                            <Checkbox
                                                                onChange={(e) =>
                                                                    handleRowSelected(
                                                                        `${ele?.month}/${ele?.year}`, // Using format "10/11-2024"
                                                                        e.target.checked // checked status
                                                                    )
                                                                }
                                                            />

                                                        }
                                                    </TableCell>


                                                    {/* Render details */}
                                                    {groupedTable[0]?.detailsArray?.map((detail, index) => {
                                                        const detailKey = Object.keys(detail)[0];
                                                        const detailData = ele.detailsArray.find(d => Object.keys(d)[0] === detailKey) || {};
                                                        return (
                                                            <React.Fragment key={index}>
                                                                <TableCell
                                                                    className={classes.bordercolors}
                                                                    style={{ textAlign: "center", cursor: "pointer", color: 'blue', background: 'white', textDecoration: 'underline' }}
                                                                    onClick={(e) => dataBasedOnClick(e, ele, detailKey)}
                                                                >
                                                                    {(detailData[detailKey]?.count || 0).toFixed(2)}
                                                                </TableCell>
                                                                <TableCell
                                                                    className={classes.bordercolors}
                                                                    style={{ textAlign: "center", cursor: "pointer", color: 'blue', background: 'white', textDecoration: 'underline' }}
                                                                    onClick={(e) => dataBasedOnClick(e, ele, detailKey)}
                                                                >
                                                                    {(detailData[detailKey]?.value || 0).toFixed(2)}
                                                                </TableCell>
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                    <TableCell className={classes.bordercolors} style={{ textAlign: "center", background: 'white', color: 'rgb(0, 77, 64)', textDecoration: 'underline', fontWeight: 'bold', cursor: 'pointer' }} onClick={(e) => dataBasedOnClick(e, ele, "total")}>
                                                        {(ele?.totalCount || 0).toFixed(2)}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} style={{ textAlign: "center", background: 'white', color: 'rgb(0, 77, 64)', textDecoration: 'underline', fontWeight: 'bold', cursor: 'pointer' }} onClick={(e) => dataBasedOnClick(e, ele, "total")}>
                                                        {(ele?.grandTotal || 0).toFixed(2)}
                                                    </TableCell>
                                                </TableRow>
                                            </>)))}

                                    {/* Totals Row */}
                                    <TableRow>
                                        <TableCell className={classes.bordercolors} style={{ textAlign: 'center', fontWeight: 'bold', position: 'sticky', left: 0, background: '#3F51B5', color: 'white' }}>
                                            Grand Total
                                        </TableCell>
                                        {groupedTable[0]?.detailsArray?.map((detail, index) => {
                                            const detailKey = Object.keys(detail)[0];
                                            const totalCount = groupedTable.reduce((acc, ele) => acc + (ele.detailsArray.find(d => Object.keys(d)[0] === detailKey)?.[detailKey]?.count || 0), 0);
                                            const totalValue = groupedTable.reduce((acc, ele) => acc + (ele.detailsArray.find(d => Object.keys(d)[0] === detailKey)?.[detailKey]?.value || 0), 0);

                                            const handleClick = (e) => {
                                                // Construct the object with clicked heading (status)
                                                const obj = {
                                                    year: 'Grand Total',
                                                    month: 'Total',
                                                    status: detailKey // Include the clicked heading here
                                                };

                                                // Send the object with the heading to dataBasedOnClick
                                                dataBasedOnClick(e, obj, detailKey);
                                            };

                                            return (
                                                <React.Fragment key={index}>
                                                    {detail?.month !== 13 && (
                                                        <>
                                                            <TableCell
                                                                className={classes.bordercolors}
                                                                style={{ textAlign: 'center', fontWeight: 'bold', background: 'white', color: 'rgb(0, 77, 64)', textDecoration: 'underline', fontWeight: 'bold', cursor: 'pointer' }}
                                                                onClick={handleClick}
                                                            >
                                                                {totalCount.toFixed(2)}
                                                            </TableCell>
                                                            <TableCell
                                                                className={classes.bordercolors}
                                                                style={{ textAlign: 'center', fontWeight: 'bold', background: 'white', color: 'rgb(0, 77, 64)', textDecoration: 'underline', fontWeight: 'bold', cursor: 'pointer' }}
                                                                onClick={handleClick}
                                                            >
                                                                {totalValue.toFixed(2)}
                                                            </TableCell>
                                                        </>)}
                                                </React.Fragment>
                                            );
                                        })}

                                        {/* Grand Total cell for the total count */}
                                        <TableCell
                                            className={classes.bordercolors}
                                            style={{ textAlign: "center", fontWeight: 'bold', background: 'white', color: 'rgb(0, 77, 64)', textDecoration: 'underline', fontWeight: 'bold', cursor: 'pointer' }}
                                            onClick={() => {
                                                const totalCount = groupedTable.reduce((acc, ele) => acc + (ele?.totalCount || 0), 0).toFixed(2);
                                                const obj = {
                                                    year: 'Grand Total',
                                                    month: 'Total',
                                                    status: 'total' // Static status for Total
                                                };
                                                dataBasedOnClick(null, obj, 'total');
                                            }}
                                        >
                                            {groupedTable.reduce((acc, ele) => acc + (ele?.totalCount || 0), 0).toFixed(2)}
                                        </TableCell>

                                        <TableCell className={classes.bordercolors} style={{ textAlign: "center", fontWeight: 'bold', background: 'white', color: 'rgb(0, 77, 64)', textDecoration: 'underline', fontWeight: 'bold', cursor: 'pointer' }}
                                            onClick={() => {
                                                const grandTotal = groupedTable.reduce((acc, ele) => acc + (ele?.grandTotal || 0), 0).toFixed(2);
                                                const obj = {
                                                    year: 'Grand Total',  // Assuming grandTotal acts as year data
                                                    month: 'Total',    // Static value for month
                                                    status: 'total'    // Static status for Total
                                                };
                                                // Send this object when clicking on the grandTotal cell
                                                dataBasedOnClick(null, obj, 'total');
                                            }}>
                                            {groupedTable.reduce((acc, ele) => acc + (ele?.grandTotal || 0), 0).toFixed(2)}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>



                }

            </div>
            <Modal
                title={pivot}
                centered
                visible={showDetailedModal}
                onCancel={() => setShowDetailedModal(false)}
                width={1000}
                maskClosable={true}
                footer={null}
            >
                <div className={classes.csv}>
                    <CSVLink
                        headers={headers}
                        filename={`${pivot}.csv`}
                        data={csvData}
                        ref={csvButtonRef}
                    />
                    <Button
                        onClick={() => csvDownloadHandler(popMonthData)}
                        style={{ backgroundColor: "#355025",color:"#FFF2EB" }}
                        variant="contained"
                        color="secondary"
                    >
                        Download CSV
                    </Button>
                </div>
                {popMonthData && (
                    <TableContainer component={Paper} className={classes.table}>
                        <Table
                            style={{ width: 450 }}
                            className={classes.table}
                            stickyHeader
                            aria-label="sticky table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sl. No.</StyledTableCell>
                                    <StyledTableCell>Project No.</StyledTableCell>
                                    <StyledTableCell>Lead No.</StyledTableCell>
                                    <StyledTableCell>Client Name</StyledTableCell>
                                    <StyledTableCell>Value (INR)</StyledTableCell>
                                    <StyledTableCell>City</StyledTableCell>
                                    <StyledTableCell>Exp. Ctr. Name</StyledTableCell>
                                    <StyledTableCell>Sales Won Date</StyledTableCell>
                                    <StyledTableCell>Design Sign-Off Date</StyledTableCell>
                                    <StyledTableCell>Material Delivery Date</StyledTableCell>
                                    <StyledTableCell>Actual Completion Date</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {popMonthData?.map((data, i) => {
                                    return (
                                        <StyledTableRow key={i}>
                                            <StyledTableCell>{i + 1}</StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {/* {data?.leadId?.erpProjectNo || "N/A"} */}

                                                {
                                                    data?.leadId?.erpProjectNo ?
                                                        <Link to={`/project-logs/${data?.leadId?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data?.leadId?.erpProjectNo}</Link> :
                                                        'NA'
                                                }

                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {/* {data?.leadId?.lead_no} */}

                                                {
                                                    data?.leadId?.lead_no ?
                                                        <Link to={`/project-logs/${data?.leadId?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data?.leadId?.lead_no}</Link> :
                                                        'NA'
                                                }

                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.leadId?.customerId?.name}
                                            </StyledTableCell>
                                            {
                                                <>
                                                    <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                        {status === "completed"
                                                            ? ((data?.leadId?.staticDesignWonAmount / 1.18) / 100000)?.toLocaleString("en-IN", {
                                                                maximumFractionDigits: 2, // Maximum number of decimal places
                                                                style: "currency",
                                                                currency: "INR",
                                                            })
                                                            : data?.leadId?.staticSalesWonBudget?.toLocaleString("en-IN", {
                                                                maximumFractionDigits: 2, // Maximum number of decimal places
                                                                style: "currency",
                                                                currency: "INR",
                                                            })
                                                        }
                                                    </StyledTableCell>
                                                </>
                                            }
                                            <StyledTableCell>
                                                {data?.salesExpCenter?.locationId?.name}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.salesExpCenter?.name}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.SalesWonDate
                                                    ? moment(data?.SalesWonDate).format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.leadId?.customerDesignSignOffDate
                                                    ? moment(data?.leadId?.customerDesignSignOffDate).format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.leadId?.materialDispatchedDate
                                                    ? moment(data?.leadId?.materialDispatchedDate).format(
                                                        "DD-MM-YYYY"
                                                    )
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.leadId?.executionCompletionDate
                                                    ? moment(data?.leadId?.executionCompletionDate).format(
                                                        "DD-MM-YYYY"
                                                    )
                                                    : "-"}
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Modal>
        </div >
    );
}

export default connect(null, { setLoading, setSnackInfo })(DesignSummary);
